import React, { useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router";
import {
  sendEmailVerification,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth, db } from "../authentication/firebase";
import Info from "../components/modals/Info";
import LoadingButton from "../components/LoadingButton";
import BackdropWrapper from "../components/modals/BackdropWrapper";
import { alertActions } from "../store/alertSlice";
import { useDispatch } from "react-redux";
import logo from "../assets/wroot-logo.png";
import ForgotPass from "../components/modals/ForgotPass";
import loginImg from "../assets/login-dk.png";
import loginMobile from "../assets/login-mobile.jpg";
import SignInWithoutEmail from "../authentication/SignInWithoutEmail";
import { doc, getDoc } from "firebase/firestore";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { motion } from "framer-motion";
import MainNav from "../components/navbar/MainNav";

export default function Login() {
  const [inputs, setInputs] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [forgotPassBackdrop, setForgotPassBackdrop] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  let { from } = location.state || { from: "/" };

  function inputChangeHandler(event) {
    setInputs((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { user } = await signInWithEmailAndPassword(
        auth,
        inputs.email,
        inputs.password
      );

      if (user.emailVerified) {
        // const userDocRef = doc(db, "userInfo", user.uid);
        // const userDoc = await getDoc(userDocRef);

        // if (userDoc.exists() && userDoc.data().serviceArea) {
        //   navigate(`/p/${userDoc.data().userName}`);
        // } else {
        console.log("location", location.state)
          navigate(from);
        // }
      } else {
        await sendEmailVerification(user);
        dispatch(
          alertActions.setAlert({
            title: "Email not Verified",
            messageType: "warning",
          })
        );
        setBackdrop(true);
      }
    } catch (e) {
      console.log("Failed to login", JSON.stringify(e));
      dispatch(
        alertActions.setAlert({
          title: JSON.parse(JSON.stringify(e)).code,
          messageType: "warning",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledLogin>
      <MainNav className="main-nav" />
      <BackdropWrapper
        backdropHandler={() => setForgotPassBackdrop((current) => !current)}
        element={
          <ForgotPass
            backdropHandler={() => setForgotPassBackdrop((current) => !current)}
          />
        }
        smallSize={true}
        open={forgotPassBackdrop}
      />
      <BackdropWrapper
        backdropHandler={() => setBackdrop(false)}
        element={
          <Info
            heading="Email Verification"
            msg="Email verification link has been sent to your email, please verify and login."
            backdropHandler={() => setBackdrop(false)}
          />
        }
        smallSize={true}
        open={backdrop}
      />
      <motion.div 
        className="left"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <img src={loginImg} alt="" />
      </motion.div>
      <motion.div 
        className="right"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <div className="content">
          <motion.img 
            className="logo" 
            src={logo} 
            alt=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          />
          <motion.div 
            className="register-form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="heading">
              <h3>Hey, Planter!</h3>
              <p className="subheading">
                Help us nurture forests for a sustainable future.
              </p>
            </div>
            <form onSubmit={submitHandler}>
              <div className="input-wrapper">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={inputs.email}
                  onChange={inputChangeHandler}
                  required
                />
              </div>
              <div className="input-wrapper">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={inputs.password}
                  onChange={inputChangeHandler}
                  minLength={8}
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <LoadingButton loading={loading} type="submit">
                Login
              </LoadingButton>
              <span
                className="link forgot-pass"
                onClick={() => setForgotPassBackdrop(true)}
              >
                Forgot password?
              </span>
            </form>
            <SignInWithoutEmail />
            <div className="link-p">
              <span className="link">Don't have an account? </span>
              <Link to="/signup" state={{ from }}>
                Sign Up
              </Link>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </StyledLogin>
  );
}

const StyledLogin = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
  overflow: hidden;
  position: relative;
  width: 100%;

  .main-nav {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    z-index: 100;
  }

  .left {
    flex-basis: 75%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    z-index: 10;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: right;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    align-items: center;
    justify-content: center;
    .heading {
      h3 {
        margin-bottom: 0.5rem;
        color: var(--text-light-color);
        font-weight: 900;
      }
      .subheading {
        margin-bottom: 2rem;
      }
    }
    .link {
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
      margin-bottom: 1rem;
    }
    .logo {
      max-width: 100px;
    }
    .content {
      width: 90%;
      background-color: white;
      padding-top: 30px;
      border-radius: 20px;
    }
    .register-form {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: linear-gradient(
        rgb(255, 255, 255, 0.9),
        rgb(255, 255, 255, 0.1) 95%
      );
      padding: 5% 0;
      border-radius: 50px;
      form {
        display: grid;
        grid-template-rows: repeat(4, 1fr);
        width: 70%;
        margin: 5% 0;
          .input-wrapper {
            position: relative;
            width: 300px;
            margin: 15px auto;
            .input-icon {
              position: absolute;
              left: 15px;
              top: 50%;
              transform: translateY(-50%);
              color: var(--gray-light-color);
              font-size: 1.2rem;
              z-index: 5;
            }
            input {
              width: 100%;
              padding-left: 45px;
              padding-right: 45px;
              box-sizing: border-box;
              position: relative;
            }
            .password-toggle {
              position: absolute;
              right: 8px;
              top: 15%;
              transform: translateY(-50%);
              color: var(--gray-light-color);
              font-size: 1rem;
              cursor: pointer;
              padding: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 28px;
              height: 28px;
              transition: all 0.2s ease;
              z-index: 10;
              background: none;
              border: none;
              
              &:hover {
                color: var(--primary-color);
                background-color: rgba(133, 206, 51, 0.1);
                transform: translateY(-50%) scale(1.05);
              }
              
              &:focus {
                outline: none;
                color: var(--primary-color);
                background-color: rgba(133, 206, 51, 0.15);
              }
              
              &:active {
                transform: translateY(-50%) scale(0.95);
              }
            }
          }
        button {
          margin: 15px auto;
          width: 300px;
        }
      }
    }
    .link-p {
      margin-top: 2rem;
      span {
        text-decoration: none;
      }
      a {
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 1rem;
        color: var(--text-light-color);
      }
    }
  }
  @media (max-width: 1000px) {
    background: url(${loginMobile}) no-repeat center center;
    background-size: cover;
    .left {
      display: none;
    }
    .right {
      flex-basis: 100%;
      .register-form {
        background: linear-gradient(
          rgb(255, 255, 255, 0.95),
          rgb(255, 255, 255, 0.8) 95%
        );
      }
    }
  }

  @media (max-width: 768px) {
    .right .content {
      width: 100%;
      .register-form {
        form {
          width: 100%;
          .input-wrapper {
            width: 260px;
          }
          button {
            width: 260px;
          }
        }
      }
    }
  }
`;
